import ErrorBoundary from "components/ErrorBoundary";
import { ComponentType } from "react";

export const withErrorBoundary = <Props extends object>(
  Component: ComponentType<Props>,
  customErrorTitle?: string
) => {
  return (props: Props) => (
    <ErrorBoundary customErrorTitle={customErrorTitle ?? "Error"}>
      <Component {...props} />
    </ErrorBoundary>
  );
};
